import React from 'react'
import { PartnerName } from './quote.interface'

enum IconType {
  LOADING = 'loading',
  ERROR = 'error',
  CHECK = 'check',
  CALENDAR = 'calendar',
  ARROW_DOWN = 'arrow-down',
  DOT = 'dot',
  CREATE = 'create',
  CHEVRON_LEFT = 'chevron-left',
  CHEVRON_RIGHT = 'chevron-right',
  BEACH_ACCESS = 'beach-access',
  FILE_COPY = 'file-copy',
  ADD = 'add',
  REMOVE = 'remove',
  POLICY = 'policy',
  UMBRELLA = 'umbrella',
  INVOICE = 'invoice',
}

interface DefaultIconComponentsMap {
  [iconType: string]: React.ElementType
}

interface CircleKIconComponentsMap {
  [iconType: string]: React.ElementType
}

interface DefaultIconProps {
  size?: number
  thickness?: 2.5
}

interface CircleKIconProps {
  type: IconType
  width?: number
  height?: number
  color?: string
}

interface DefaultIconPropsMap {
  [iconType: string]: DefaultIconProps
}

interface CircleKIconPropsMap {
  [iconType: string]: CircleKIconProps
}

type PartnersIcons = Record<
  PartnerName,
  {
    components: DefaultIconComponentsMap | CircleKIconComponentsMap
    props: DefaultIconPropsMap | CircleKIconPropsMap
  }
>

export {
  DefaultIconProps,
  CircleKIconProps,
  DefaultIconComponentsMap,
  CircleKIconComponentsMap,
  DefaultIconPropsMap,
  CircleKIconPropsMap,
  PartnersIcons,
  IconType,
}
